import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 10%;
    padding-top: 8px;
    float: left;
    height: 36px;
    text-align: center;
    border-right: 1px solid #979797;
    box-sizing: border-box;
    cursor: pointer;

    &:nth-child(10) {
        border: 0;
    }

    ${(props) => (props.active ? {
    'background': '#979797',
    'color': 'white'
} : '')}
`;